// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, objectOf, anyOf } from "@altostra/type-validations";
import { string, nullOrUndefined } from "@altostra/type-validations/lib/primitives";

export const isEngagementAppGroupIdSmsInboundMessageKeywordCategoriesResult = arrayOf(
  objectOf({
    id: anyOf(string, nullOrUndefined),
    name: string,
  })
);
